export const white              = '#ffffff';
export const black              = `#000`;
export const primaryColor       = `#005485`;
export const primaryHoverColor  = `#197BBD`;
export const fontColor          = `#000000A5`;
export const lightFontColor     = `#00000040`;
export const red                = `rgb(100 136 13)`;
export const warning            = '#ffa940';
export const warningHover        = '#fa8c16';
export const warningFont        = '#873800';
export const secondaryFontColor = `#00304D`;
export const bgColor            = `#f1f1f1`;
export const highlightColor     = `#13E388`;
export const lightGrey          = `#E0E2E8`;
export const borderHoverColor     = `#005485`;
export const buttonPrimaryBgColor = `#005485`;

export const menuTagColor       = `#005485`;
export const menuTagBgColor     = `#fff`;
export const menuTagBorderColor = `#005485`;
export const headerColor        = `rgb(0 84 133 / 70%)`;
export const borderColor        = '#000000A5';
